export default __webpack_public_path__ + "static/media/coracao.35927897.svg";